import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Made with <span className="heart">❤</span> from scratch by me!</p>
    </footer>
  );
};

export default Footer;
